/*
 * @Author: majunfeng
 * @Date: 2019-05-06 10:22:47
 * @Last Modified by: majunfeng
 * @Last Modified time: 2019-05-06 12:49:00
 */
import tinycolor from "tinycolor2";
import { normal } from "color-blend";
// tslint:disable:no-parameter-reassignment
/**
 * 合成颜色，遵循W3c标准，和半透明的div效果相同
 * @see https://www.w3.org/TR/compositing-1/#simplealphacompositing
 * @author 马俊峰
 * @date 2019-05-06
 * @export
 * @param {string} color1 底色
 * @param {string} color2 覆盖色
 * @returns
 */
export function syntheticColors(color1, color2) {
    const rgb1 = tinycolor(color1).toRgb();
    const rgb2 = tinycolor(color2).toRgb();
    const rgba = normal(rgb1, rgb2);
    return tinycolor(rgba).toRgbString();
}
//# sourceMappingURL=index.js.map